class CollectionLayout extends HTMLElement {
  constructor() {
    super();
    this.gridButtons = this.querySelectorAll('button[data-id]');
    this.productGrid = document.querySelector('.product-grid__list');
    this.cartData = JSON.parse(document.getElementById('cart-data').textContent);
    console.log(this.cartData, this.gridButtons, this.productGrid);

    this.debounceTimeout = null; // Initialize debounce timeout

    this.init();
  }

  init() {
    this.restoreGridSetting();

    this.gridButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.productGrid = document.querySelector('.product-grid__list');
        const gridId = button.dataset.id;
        const mobileGridId = button.dataset.mobileGrid;

        this.updateActiveClass(gridId);
        if (this.productGrid) {
          this.updateProductGridClass(gridId, mobileGridId);
        }
        this.debounce(() => {
          this.updateCartAttribute(gridId, mobileGridId);
        }, 500);
      });
    });
  }

  restoreGridSetting() {
    const savedGrid = this.cartData.attributes['collection-grid-layout'];
    const savedMobileGrid = this.cartData.attributes['collection-mobile-grid-layout'];
    if (savedGrid) {
      this.updateActiveClass(savedGrid);
      if (this.productGrid) {
        this.updateProductGridClass(savedGrid, savedMobileGrid);
      }
    }
  }

  updateCartAttribute(gridId, mobileGridId) {
    this.cartData.attributes['collection-grid-layout'] = gridId;
    this.cartData.attributes['collection-mobile-grid-layout'] = mobileGridId; // Add mobile grid class to cart attributes
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: this.cartData.attributes,
      }),
    })
      .then(response => response.json())
      .then(updatedCart => {
        console.log('Cart updated successfully:', updatedCart);
      })
      .catch(error => console.error('Error updating cart attribute:', error));
  }

  updateActiveClass(activeId) {
    this.gridButtons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.id === activeId);
    });
  }

  updateProductGridClass(newClass, mobileClass) {
    const gridClasses = Array.from(this.productGrid.classList).filter(cls =>
      cls.startsWith('grid--')
    );
    gridClasses.forEach(cls => this.productGrid.classList.remove(cls));

    this.productGrid.classList.add(newClass);

    if (mobileClass) {
      this.productGrid.classList.add(mobileClass);
    }
  }

  getMobileGridClass(desktopClass) {
    const button = Array.from(this.gridButtons).find(btn => btn.dataset.id === desktopClass);
    return button ? button.dataset.mobileGrid : null;
  }

  debounce(callback, delay) {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(callback, delay);
  }
}

customElements.define('collection-layout', CollectionLayout);